import React from 'react';
import { Category, Screen } from '../../types';
import { useNavigation } from '../../context/NavigationContext';
interface CategoryCardProps {
  category: Category;
  layout?: 'horizontal' | 'grid';
}
export function CategoryCard({
  category,
  layout = 'horizontal'
}: CategoryCardProps) {
  const {
    navigate
  } = useNavigation();
  return <button onClick={() => navigate(Screen.PRODUCT_LIST, {
    categoryId: category.id,
    categoryName: category.name
  })} className={`flex flex-col items-center gap-2 active:scale-95 transition-transform ${layout === 'horizontal' ? 'w-[72px] shrink-0' : 'w-full'}`} data-id="element-104">
      <div className={`
        flex items-center justify-center bg-white rounded-2xl shadow-sm border border-gray-50
        ${layout === 'horizontal' ? 'w-16 h-16' : 'w-full aspect-square'}
      `} data-id="element-105">
        <span className="text-3xl" data-id="element-106">{category.icon}</span>
      </div>
      <span className="text-xs font-medium text-gray-700 text-center line-clamp-1 w-full" data-id="element-107">
        {category.name}
      </span>
    </button>;
}